import React, { useState } from 'react';
import { Button, Input, Label } from 'reactstrap'; // Replace with your actual UI library imports

const AddSectionModal = ({ isOpen, onClose, onAdd, type }) => {
  const [sectionName, setSectionName] = useState('');

  const handleAdd = () => {
    if (sectionName.trim()) {
      onAdd(sectionName.trim());
      setSectionName(''); // Clear the input after adding
      onClose(); // Close the modal
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="mb-4">
          {type ? 'Enter Template Name' : 'Add New Section'}
        </h2>
        <div className="form-group">
          <Input
            id="sectionName"
            type="text"
            value={sectionName}
            onChange={(e) => setSectionName(e.target.value)}
            placeholder={type ? 'Enter Template Name' : 'Enter section name'}
          />
        </div>
        <div className="modal-buttons">
          <Button color="primary" onClick={handleAdd}>
            Save
          </Button>
          <Button color="secondary" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddSectionModal;
